import service from "../services/promotions.service";

export const promotions = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        async getPaginated(context, params) {
            try {
                const response = await service.getPaginated(params);
                return response;
            } catch (error) {
                console.error("Error fetching paginated data:", error);
                throw error.response;
            }
        },
        async getById(context, id) {
            try {
                const response = await service.getById(id);
                return response;
            } catch (error) {
                throw error.response;
            }
        },
        async searchProducts(context, params) {
            try {
                const response = await service.searchProducts(params);
                return response;
            } catch (error) {
                throw error.response;
            }
        },
        async save(context, data) {
            try {
                let response;
                if (data.id === 0) {
                    response = await service.createData(data);
                } else {
                    response = await service.updateData(data.id, data);
                }
                return response;
            } catch (error) {
                console.error("Error saving data:", error);
                throw error.response;
            }
        },
        async delete(context, id) {
            try {
                const response = await service.deleteData(id);
                return response;
            } catch (error) {
                throw error.response;
            }
        },
    },
    mutations: {
    },
};
